<template>
  <div id="Video">
    <youtube
      class="videoLoop"
      :video-id="videoId"
      :player-vars="playerVars"
      @playing="playing"
      @ready="ready"
      @ended="ended"
      ref="youtube"
    ></youtube>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoId: '',
      playerVars: {
        autoplay: 1,
      },
      videoIds: ['ueVSh8-f64Y', 'aL1hh7SgkYE', 'O1ZAUHtpHBw', 'TEs0KUmprxw'],
    };
  },
  mounted() {
    this.videoId = this.videoIds[0];
  },
  methods: {
    playVideo() {
      this.player.playVideo();
    },
    ready() {},
    playing() {},
    ended() {
      console.log('ended');
      if (this.videoIds.length > 1) {
        this.playNextVideo();
      } else {
        this.player.seekTo(0);
      }
    },
    playNextVideo() {
      let currentIdx = this.videoIds.indexOf(this.videoId);
      let nextIdx = currentIdx + 1 >= this.videoIds.length ? 0 : currentIdx + 1;
      this.videoId = this.videoIds[nextIdx];
      this.playVideo();
    },
  },
  computed: {
    player() {
      return this.$refs.youtube.player;
    },
  },
};
</script>
<style>
.videoLoop {
  width: 80%;
  height: auto;
  aspect-ratio: 16 / 9;
  display: block;
  margin: 0 auto;
}
</style>
